import { useDispatch } from 'react-redux';
import { getNextAllowStatus, migrateToUploadedDoc } from '../../modules/crm/inPatient/service/crmUtils';
import { setUploadedFiles } from '../../store/actions/newAdmissionAction';

const useMigrateRiClaimData = (): any => {
  const dispatch = useDispatch();

  const migrateRIClaimDetail = (claimDetail: any): any => {
    const [{ actionName } = { actionName: null }] = getNextAllowStatus(claimDetail?.allowStatus);
    claimDetail['nextAllowStatus'] = actionName ? [actionName] : [];

    if (claimDetail?.claimFlowData?.length) {
      const allDocuments = migrateToUploadedDoc(claimDetail?.claimFlowData);
      dispatch(setUploadedFiles(allDocuments));
    }
    return {
      ...claimDetail,
      fullName: claimDetail?.patientName || '',
      mobile: claimDetail?.patientMobileNo || '',
      emailId: claimDetail?.patientEmailId || '',
      // memberId: claimDetail?.memberId,
      policyNumber: claimDetail?.policyNo || '',
      corporateName: claimDetail?.policyHolderName || '',
      // dateOfAdmission: claimDetail?.doa,
      // dateOfDischarge: claimDetail?.dod,
      // procedure: claimDetail?.procedure
    };
  };
  return { migrateRIClaimDetail };
};
export default useMigrateRiClaimData;
